import React from 'react';
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';
import Bold from 'components/Bold';
import { WorksheetPageIndex } from 'services/worksheet/types';
import FertilizerPrintWorksheetCompletionDetailsTable from './components/FertilizerPrintWorksheetCompletionDetailsTable';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export default function FertilizerPrintWorksheetCompletionDetails(
    props: Props
): React.ReactElement {
    const { pageIndex } = props;

    return (
        <div className="print-worksheet-page-section">
            <Grid columns="1">
                <GridRow>
                    <GridColumn>
                        <Bold>Completion details</Bold>
                    </GridColumn>
                </GridRow>
            </Grid>
            <FertilizerPrintWorksheetCompletionDetailsTable
                pageIndex={pageIndex}
            />
        </div>
    );
}
